import React from 'react';

import PropTypes from 'prop-types';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import { useNavigate } from 'react-router-dom';

import actions from 'components/Admin/Avatars/Actions/Actions';

export default function Actions({ row, refresh }) {
  const navigate = useNavigate();

  const onEditClick = () => {
    navigate(`/admin/avatars/${row.id}/edit`);
  };

  const onDeleteClick = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete AI Coach?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.destroy(row.id, () => {
            refresh();
          });
        }
      },
    );
  };

  return (
    <div>
      <a onClick={onEditClick} className="mr10">
        <img src={editIcon} />
      </a>

      <a onClick={(e) => onDeleteClick(e)}>
        <img src={deleteIcon} />
      </a>

    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  refresh: PropTypes.func.isRequired,
};
